export const FILTER_CONNECTOR_ALL = 'All';

export const FILTER_CONNECTOR_ANY = 'Any';
